import {
  DialogTitle as MUIDialogTitle,
  DialogTitleProps as MUIDialogTitleProps,
} from '@mui/material';
import Divider from '../../../Divider';
import IconButton from '../../../IconButton';
import Typography from '../../../Typography';
import { CloseIcon } from '../../../../icons';
import { B1 } from '../../../../theme';
import { mergeSX } from '../../../../services/helpers';

export interface DialogTitleProps extends MUIDialogTitleProps {
  onClose?: () => void;
  isLoading?: boolean;
}

const buildSX = () => ({
  '&.MuiDialogTitle-root': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px',
  },
  '.MuiIconButton-root': {
    padding: 0,
  },
  '.MuiTypography-root': {
    fontWeight: 600,
    fontSize: 20,
    lineHeight: '30px',
  },
});

const DialogTitle = (props: DialogTitleProps) => {
  const {
    children, onClose, isLoading = false, sx, ...restProps
  } = props;

  return (
    <>
      <MUIDialogTitle sx={mergeSX(buildSX(), sx)} {...restProps}>
        <Typography variant="h6" component="span">{children}</Typography>
        {onClose && (
        <IconButton disabled={isLoading} onClick={onClose}>
          <CloseIcon color={B1} />
        </IconButton>
        )}
      </MUIDialogTitle>
      <Divider />
    </>
  );
};

export default DialogTitle;
